
import Lock from "../../../assets/duotone/Lock.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LockIcon({ className, dataTestid = "LockIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Lock data-testid={dataTestid} className={classes} {...rest} />
  );
}
